import MobileAccordianCommon from "components/searchBar/mobile-tablet-view/accordian-common/MobileAccordianCommon";
import SearchGuestContent from "components/searchBar/mobile-tablet-view/SearchGuest/SearchGuestContent";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { markLocalSearch, selectLocalSearchGuests } from "stores/local-search/localSearchSlice";
import { handleGuestValue } from "utils/helper";
import { useUserAgentInfo } from "utils/hooks/useUserAgentInfo";

// The accordion component for the guest section the mobile & table view of the search bar
const GuestAccordian = () => {
  const localSearchGuest = useAppSelector(selectLocalSearchGuests);
  const dispatch = useAppDispatch();

  // Get the guest details from the local search state
  const guestDetails = {
    adultCount: localSearchGuest.adultCount || 0,
    childCount: localSearchGuest.childrenCount || 0,
    petsAllowed: localSearchGuest.petAllowed || false
  };
  const {
    isIOSAndSafari
  } = useUserAgentInfo();
  return <MobileAccordianCommon currentTab='guest' title='Who’s coming?' className={`max-h-[200px] pb-4 ${isIOSAndSafari ? "" : "px-4"}`} additionalSummaryContent={<p className='text-sm font-semibold leading-[14px] tracking-[-0.14px] text-[#26262B]'>
          {localSearchGuest.adultCount || localSearchGuest.childrenCount || localSearchGuest.petAllowed ? handleGuestValue(guestDetails) : "Add guests"}
        </p>} data-sentry-element="MobileAccordianCommon" data-sentry-component="GuestAccordian" data-sentry-source-file="GuestAccordian.tsx">
      {/* Component to manage and display guest counts */}
      <SearchGuestContent initialState={guestDetails} onChange={res => {
      dispatch(markLocalSearch({
        locationData: {
          page: 0
        },
        guestDetails: {
          adultCount: res.adult,
          childrenCount: res.child,
          petAllowed: res.pets,
          numberOfGuest: res.adult + res.child,
          childAllowed: res.child > 0
        }
      }));
    }} data-sentry-element="SearchGuestContent" data-sentry-source-file="GuestAccordian.tsx" />
    </MobileAccordianCommon>;
};
export default GuestAccordian;